import React from 'react';
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import useModal from "components/modal/useModal";
import qrCodeImage from "assets/images/qrcode-app.svg";

const appStoreLinks = {
    ios: process.env.REACT_APP_IOS_STORE_URL_PRO || 'https://apps.apple.com/app/jobbiz-pro',
    android: process.env.REACT_APP_ANDROID_STORE_URL_PRO || 'https://play.google.com/store/apps/details?id=com.mycompany.jobbizpro',
};

const ModalAppPro = () => {
    const { toggle } = useModal();

    return (
        <>
            <Modalheader hide={toggle} hideShow={true}>
                Télécharger l'app pro
            </Modalheader>
            <ModalBody>
                <div className="flex flex-col items-center gap-6">
                    <div className="flex justify-center">
                        <img
                            src={qrCodeImage}
                            alt="QR Code pour télécharger l'application mobile Jobbiz Pro"
                            className="w-64 h-64 border border-gray-200 rounded-lg p-2 bg-white"
                        />
                    </div>
                    <p className="text-center text-gray-600 ft-b">
                        Scannez le QR code avec votre smartphone pour télécharger l'application
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center items-center w-full">
                        <a
                            href={appStoreLinks.ios}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-block"
                        >
                            <Button color="PRIMARY" size="LG">
                                <div className="flex items-center gap-2">
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                                    </svg>
                                    <span>Télécharger pour iOS</span>
                                </div>
                            </Button>
                        </a>
                        <a
                            href={appStoreLinks.android}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-block"
                        >
                            <Button color="PRIMARY" size="LG">
                                <div className="flex items-center gap-2">
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                                        <path d="M12 8V4H8"/>
                                        <rect width="16" height="12" x="4" y="8" rx="2"/>
                                        <path d="M2 14h2"/>
                                        <path d="M20 14h2"/>
                                        <path d="M15 13v2"/>
                                        <path d="M9 13v2"/>
                                    </svg>
                                    <span>Télécharger pour Android</span>
                                </div>
                            </Button>
                        </a>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button size="LG" color="SECONDARY" onClick={toggle}>Fermer</Button>
            </ModalFooter>
        </>
    );
};

export default ModalAppPro;
